import { KeywordsTextTypeView } from '../../components/DisplayConditions/DisplayConditions';
import { BannerId, GroupPlacementsSummary } from '../../typings/banners';
import { CampaignId, CopyTooltipStatus } from '../../typings/domain';
import { GroupId } from '../../typings/groups';
import { TruncatedUserProfile } from '../../typings/userProfileRetargeting';

export const ON_CHANGE_OPEN_STATE_DISPLAY_CONDITIONS = 'ON_CHANGE_OPEN_STATE_DISPLAY_CONDITIONS';
export type ON_CHANGE_OPEN_STATE_DISPLAY_CONDITIONS = typeof ON_CHANGE_OPEN_STATE_DISPLAY_CONDITIONS;
export interface OnChangeOpenStateDisplayConditions {
    type: ON_CHANGE_OPEN_STATE_DISPLAY_CONDITIONS;
    id: BannerId;
    groupId: GroupId;
    campaignId: CampaignId;
}

export function onChangeOpenStateDisplayConditions(
    id: BannerId,
    groupId: GroupId,
    campaignId: CampaignId
): OnChangeOpenStateDisplayConditions {
    return {
        type: ON_CHANGE_OPEN_STATE_DISPLAY_CONDITIONS,
        id,
        groupId,
        campaignId
    };
}

export const ON_START_LOAD_KEYWORDS_AND_RETARGENTING_DISPLAY_CONDITIONS =
    'ON_START_LOAD_KEYWORDS_AND_RETARGENTING_DISPLAY_CONDITIONS';
export type ON_START_LOAD_KEYWORDS_AND_RETARGENTING_DISPLAY_CONDITIONS = typeof ON_START_LOAD_KEYWORDS_AND_RETARGENTING_DISPLAY_CONDITIONS;
export interface OnStartLoadKeywordsAndRetargetingDisplayConditions {
    type: ON_START_LOAD_KEYWORDS_AND_RETARGENTING_DISPLAY_CONDITIONS;
    id: BannerId;
    groupId: GroupId;
    campaignId: CampaignId;
}

export function onStartLoadKeywordsAndRetargetingDisplayConditions(
    id: BannerId,
    groupId: GroupId,
    campaignId: CampaignId
): OnStartLoadKeywordsAndRetargetingDisplayConditions {
    return {
        type: ON_START_LOAD_KEYWORDS_AND_RETARGENTING_DISPLAY_CONDITIONS,
        id,
        groupId,
        campaignId
    };
}

export const ON_ERROR_LOAD_KEYWORDS_AND_RETARGENTING_DISPLAY_CONDITIONS =
    'ON_ERROR_LOAD_KEYWORDS_AND_RETARGENTING_DISPLAY_CONDITIONS';
export type ON_ERROR_LOAD_KEYWORDS_AND_RETARGENTING_DISPLAY_CONDITIONS = typeof ON_ERROR_LOAD_KEYWORDS_AND_RETARGENTING_DISPLAY_CONDITIONS;
export interface OnErrorLoadKeywordsAndRetargetingDisplayConditions {
    type: ON_ERROR_LOAD_KEYWORDS_AND_RETARGENTING_DISPLAY_CONDITIONS;
    id: BannerId;
}

export function onErrorLoadKeywordsAndRetargetingDisplayConditions(
    id: BannerId
): OnErrorLoadKeywordsAndRetargetingDisplayConditions {
    return {
        type: ON_ERROR_LOAD_KEYWORDS_AND_RETARGENTING_DISPLAY_CONDITIONS,
        id
    };
}

export const ON_LOAD_KEYWORDS_AND_RETARGENTING_DISPLAY_CONDITIONS =
    'ON_LOAD_KEYWORDS_AND_RETARGENTING_DISPLAY_CONDITIONS';
export type ON_LOAD_KEYWORDS_AND_RETARGENTING_DISPLAY_CONDITIONS = typeof ON_LOAD_KEYWORDS_AND_RETARGENTING_DISPLAY_CONDITIONS;
export interface OnLoadKeywordsAndRetargetingDisplayConditions {
    type: ON_LOAD_KEYWORDS_AND_RETARGENTING_DISPLAY_CONDITIONS;
    id: BannerId;
    keywords?: string[];
    retargeting?: string[];
    userProfile?: TruncatedUserProfile;
    placements?: GroupPlacementsSummary;
}

export function onLoadKeywordsAndRetargetingDisplayConditions(
    id: BannerId,
    keywords?: string[],
    retargeting?: string[],
    userProfile?: TruncatedUserProfile,
    placements?: GroupPlacementsSummary
): OnLoadKeywordsAndRetargetingDisplayConditions {
    return {
        type: ON_LOAD_KEYWORDS_AND_RETARGENTING_DISPLAY_CONDITIONS,
        id,
        keywords,
        retargeting,
        userProfile,
        placements
    };
}

export const ON_CHANGE_TEXT_TYPE_VIEW_DISPLAY_CONDITIONS = 'ON_CHANGE_TEXT_TYPE_VIEW_DISPLAY_CONDITIONS';
export type ON_CHANGE_TEXT_TYPE_VIEW_DISPLAY_CONDITIONS = typeof ON_CHANGE_TEXT_TYPE_VIEW_DISPLAY_CONDITIONS;
export interface OnChangeTextTypeViewDisplayConditions {
    type: ON_CHANGE_TEXT_TYPE_VIEW_DISPLAY_CONDITIONS;
    id: BannerId;
    keywordsTextTypeView: KeywordsTextTypeView;
}

export function onChangeTextTypeViewDisplayConditions(
    id: BannerId,
    keywordsTextTypeView: KeywordsTextTypeView
): OnChangeTextTypeViewDisplayConditions {
    return {
        type: ON_CHANGE_TEXT_TYPE_VIEW_DISPLAY_CONDITIONS,
        id,
        keywordsTextTypeView
    };
}

export const COPY_KEYWORDS_TO_CLIPBOARD = 'COPY_KEYWORDS_TO_CLIPBOARD';
export type COPY_KEYWORDS_TO_CLIPBOARD = typeof COPY_KEYWORDS_TO_CLIPBOARD;

export interface CopyKeywordsToClipboard {
    type: COPY_KEYWORDS_TO_CLIPBOARD;
    text: string;
    id: BannerId;
}

export const copyKeywordsToClipboard = (id: BannerId, text: string): CopyKeywordsToClipboard => {
    return {
        type: COPY_KEYWORDS_TO_CLIPBOARD,
        text,
        id
    };
};

export const CHANGE_COPIED_DISPLAY_CONDITIONS_TOOLTIP_STATUS = 'CHANGE_COPIED_DISPLAY_CONDITIONS_TOOLTIP_STATUS';
export type CHANGE_COPIED_DISPLAY_CONDITIONS_TOOLTIP_STATUS = typeof CHANGE_COPIED_DISPLAY_CONDITIONS_TOOLTIP_STATUS;

export interface ChangeCopiedDisplayConditionsTooltipStatus {
    type: CHANGE_COPIED_DISPLAY_CONDITIONS_TOOLTIP_STATUS;
    newStatus: CopyTooltipStatus;
    id: BannerId;
}

export const changeCopiedDisplayConditionsTooltipStatus = (
    id: BannerId,
    newStatus: CopyTooltipStatus
): ChangeCopiedDisplayConditionsTooltipStatus => {
    return {
        type: CHANGE_COPIED_DISPLAY_CONDITIONS_TOOLTIP_STATUS,
        newStatus,
        id
    };
};

export type BannerEditDisplayConditions =
    | ChangeCopiedDisplayConditionsTooltipStatus
    | OnStartLoadKeywordsAndRetargetingDisplayConditions
    | OnErrorLoadKeywordsAndRetargetingDisplayConditions
    | CopyKeywordsToClipboard
    | OnChangeOpenStateDisplayConditions
    | OnChangeTextTypeViewDisplayConditions
    | OnLoadKeywordsAndRetargetingDisplayConditions;
